import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'sumPipe' })
export class SumPipe implements PipeTransform {
    transform(value: Array<any>): any {
        return value.reduce((a, b) => a + b, 0);
    }
}
